import { useState } from 'react';
import { downloadData } from '@/mocks/home';

export default function AppDownloadSection() {
  const [platform, setPlatform] = useState<'ios' | 'android'>('ios');

  const currentData = platform === 'ios'
    ? { version: downloadData.iosVersion, size: downloadData.iosSize }
    : { version: downloadData.androidVersion, size: downloadData.androidSize };

  return (
    <section id="download" className="py-16 md:py-20 bg-background-100">
      <div className="site-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            {downloadData.title}
          </h2>
          <p className="mt-3 text-sm text-foreground-600">{downloadData.subtitle}</p>
        </div>

        <div className="max-w-4xl mx-auto bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-10">
            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 bg-background-100 rounded-2xl flex items-center justify-center border border-background-200">
                <i className="ri-smartphone-line text-6xl md:text-7xl text-primary-500"></i>
              </div>
            </div>

            <div className="flex-1 w-full">
              <div className="flex items-center gap-2 mb-6">
                <button
                  onClick={() => setPlatform('ios')}
                  className={`flex-1 py-3 rounded-xl text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    platform === 'ios'
                      ? 'bg-foreground-900 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className="ri-apple-fill mr-2"></i>iOS 版本
                </button>
                <button
                  onClick={() => setPlatform('android')}
                  className={`flex-1 py-3 rounded-xl text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    platform === 'android'
                      ? 'bg-foreground-900 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className="ri-android-fill mr-2"></i>Android 版本
                </button>
              </div>

              <div className="flex items-center gap-6 mb-6">
                <div>
                  <span className="text-xs text-foreground-500">版本</span>
                  <p className="text-lg font-bold text-foreground-900 mt-0.5">{currentData.version}</p>
                </div>
                <div className="w-px h-8 bg-background-200"></div>
                <div>
                  <span className="text-xs text-foreground-500">大小</span>
                  <p className="text-lg font-bold text-foreground-900 mt-0.5">{currentData.size}</p>
                </div>
                <div className="w-px h-8 bg-background-200"></div>
                <div>
                  <span className="text-xs text-foreground-500">更新</span>
                  <p className="text-lg font-bold text-foreground-900 mt-0.5">2026-08-01</p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-3">
                <button className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-semibold rounded-full text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-download-cloud-2-line mr-2"></i>立即下载
                </button>
                <button className="w-full sm:w-auto px-6 py-3 bg-background-100 text-foreground-700 font-medium rounded-full text-sm hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-qr-code-line mr-2"></i>扫码下载
                </button>
              </div>

              <p className="mt-4 text-xs text-foreground-500 leading-relaxed">
                <i className="ri-shield-check-line mr-1 text-accent-500"></i>
                {downloadData.securityNote}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}